import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const onboardWms = {
  name: "onboardWms" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ success: z.boolean(), workflowId: z.string() }),
  description: "Trigger WMS bin-level inventory onboarding workflow",
};
